import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const counterSlice = createSlice({
  name: "patientSlice",
  initialState,
  reducers: {
    setPatientData: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setPatientData } = counterSlice.actions;

export default counterSlice.reducer;
